/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business portalRoles と workspace teamName に応じてログイン後のデフォルト遷移先パスを決定する。保持ロールが全て member / external (非 PDG/ACE) の場合は IDチーム (pi_idt) 所属なら /members/idt-kpi、それ以外は /my-page。1つでも他ロールを保持していれば /kpi
 * @graph-connects isInterfaceDesignTeam [calls] IDT（designer）所属の判定（team コードの唯一の置き場）
 */
import { isInterfaceDesignTeam } from '@cortex/core-types';
import type { PortalRole } from '../types/api.js';

/**
 * IDチーム看板 (IDT designer のデフォルト遷移先) のパス。
 * @graph-connects none
 */
const IDT_KPI_PATH = '/members/idt-kpi';

/**
 * portalRoles / teamName に応じたデフォルトページパス
 *
 * 保持ロールがすべて `member` / `external` の場合のみ個人向けページ。うち IDチーム
 * の designer は MyPage ではなく IDチーム看板 (`/members/idt-kpi`) を入口にする
 * （日常的に見るのが個人ページではなくチーム看板のため。IDT は canAccessPage('idtKpi') を
 * team 所属だけで満たすので権限落ちしない）。所属判定は `isInterfaceDesignTeam`
 * （`@cortex/core-types`）に委ね、team コードの値はこのファイルが持たない。
 * それ以外の member / external は `/my-page`。1つでも他ロール（admin / group_manager /
 * team_leader / architect / dle / tech_lead / pmo）を保持していれば `/kpi`。
 * @graph-connects none
 */
export function defaultRouteForRole(
  portalRoles: PortalRole[] | undefined,
  teamName?: string | null,
): string {
  if (!portalRoles || portalRoles.length === 0) return '/kpi';
  const allMemberOrExternal = portalRoles.every((role) => role === 'member' || role === 'external');
  if (!allMemberOrExternal) return '/kpi';
  return isInterfaceDesignTeam(teamName) ? IDT_KPI_PATH : '/my-page';
}
